import { v4 } from 'uuid';

export interface ICategory {
  id: number;
  displayName: string;
  formattedName: string;
  localPath: string;
}

export const categories = [
  { 
    id: 0, 
    displayName: 'Aktuellt', 
    formattedName: 'categories.current',
    localPath: '/', 
  },
  { 
    id: 1, 
    displayName: 'Teater & Underhållning',
    formattedName: 'categories.theater',
    localPath: '/teater', 
  },
  { 
    id: 2, 
    displayName: 'Sport',
    formattedName: 'categories.sport',
    localPath: '/sport', 
  },
  { 
    id: 3, 
    displayName: 'Musik', 
    formattedName: 'categories.music',
    localPath: '/musik', 
  },
  { 
    id: 4, 
    displayName: 'Familj',
    formattedName: 'categories.family',
    localPath: '/familj', 
  },
];

const dropdownDesktop = {
  displayName: 'Information & Hjälp',
  formattedName: 'menu.info',
  localPath: '/information',
  items: [
    { 
      id: v4(),
      displayName: 'Kontakt', 
      formattedName: 'menu.contact',
      localPath: '/information/kontakt', 
    },
    { 
      id: v4(),
      displayName: 'Om Julius Biljettservice', 
      formattedName: 'menu.about',
      localPath: '/information/om', 
    },
    { 
      id: v4(),
      displayName: 'Callcenter', 
      formattedName: 'menu.customerservice',
      localPath: '/information/callcenter', 
    },
    { 
      id: v4(),
      displayName: 'Frågor och svar',
      formattedName: 'menu.faq',
      localPath: '/information/faq', 
    },
    { 
      id: v4(),
      displayName: 'Våra ombud', 
      formattedName: 'menu.agents',
      localPath: '/ombud', 
    },
    { 
      id: v4(),
      displayName: 'Grupp- och företagsbokning',
      formattedName: 'menu.bookings',
      localPath: '/gruppbokning', 
    },
    { 
      id: v4(),
      displayName: 'Köpvillkor',
      formattedName: 'menu.terms',
      localPath: '/villkor',
    },
  ],
};

const dropdownMobile = {
  displayName: '',
  formattedName: '',
  localPath: '',
  items: [
    { 
      id: v4(),
      displayName: 'Musik', 
      formattedName: 'categories.music',
      localPath: '/musik', 
    },
    { 
      id: v4(),
      displayName: 'Teater & Underhållning', 
      formattedName: 'categories.theater',
      localPath: '/teater', 
    },
    { 
      id: v4(),
      displayName: 'Familj', 
      formattedName: 'categories.family',
      localPath: '/familj',
    },
    { 
      id: v4(),
      displayName: 'Sport', 
      formattedName: 'categories.sport',
      localPath: '/sport', 
    },
    { 
      id: v4(),
      displayName: 'Kontakt', 
      formattedName: 'menu.contact',
      localPath: '/information/kontakt', 
    },
    { 
      id: v4(),
      displayName: 'Om Julius Biljettservice', 
      formattedName: 'menu.about',
      localPath: '/information/om', 
    },
    { 
      id: v4(),
      displayName: 'Frågor & svar', 
      formattedName: 'menu.faq',
      localPath: '/information/faq', 
    },
    { 
      id: v4(),
      displayName: 'Våra ombud', 
      formattedName: 'menu.agents',
      localPath: '/ombud', 
    },
    { 
      id: v4(),
      displayName: 'Grupp- och företagsbokning', 
      formattedName: 'menu.bookings',
      localPath: '/gruppbokning', 
    },
    { 
      id: v4(),
      displayName: 'Köpvillkor', 
      formattedName: 'menu.terms',
      localPath: '/villkor', 
    },
    { 
      id: v4(),
      displayName: 'Arrangör', 
      formattedName: 'menu.organizer',
      localPath: '/arrangör', 
    },
  ],
};

const homeImageUrl = '/logo-color.svg';

export const staticContent = {
  homeImageUrl,
  categories,
  dropdownDesktop,
  dropdownMobile,
};


// WEBPACK FOOTER //
// ./src/components/MenuMain/MenuMainContent.tsx